import { DisplayMode } from '@r-core';
import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';
import { ReferenceEntryType } from '../types/reference-entry-type.enum';

export const backsplashPropertiesMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Backsplash Properties',
		isVisible: ({ context, controller: { navigation }}): boolean => {
			return navigation.displayMode === DisplayMode.Panel || navigation.displayMode === DisplayMode.Manufacturing || navigation.displayMode === DisplayMode.InlineManufacturing ||
				navigation.displayMode === DisplayMode.Backsplash || navigation.displayMode === DisplayMode.BacksplashManufacturing ||
				([DisplayMode.Inline, DisplayMode.InlineManufacturing, DisplayMode.Overhead, DisplayMode.OverheadManufacturing].indexOf(navigation.displayMode) !== -1 &&
					[ReferenceEntryType.Workspace, ReferenceEntryType.NoOp].indexOf(context.menuKey as ReferenceEntryType) === -1);
		},
		onClick: ({ context, controller }): void => {
			console.log('backsplashPropertiesOnClick', context);
			controller.publishShowProperties('backsplash', context.id);
		}
	}
};
